import store from 'foremanReact/redux';
import { addToast } from 'foremanReact/components/ToastsList';

export const showToast = toast => store.dispatch(addToast(toast));



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_ansible-9.0.1-1.fm3_4.el8.noarch/usr/share/gems/gems/foreman_ansible-9.0.1/webpack/toastHelper.js